var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('request-table-inns', {
    attrs: {
      "value": _vm.value,
      "regions": _vm.filterRegions,
      "is-searching": _vm.isFetching,
      "is-individual": _vm.isIndividual,
      "sort": _vm.sort,
      "records": _vm.paginatedRecords,
      "total": _vm.totalRecords,
      "display": _vm.display,
      "page": _vm.page
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', $event)
      },
      "paginate": _vm.setPage,
      "sort": _vm.setSort,
      "filter": _vm.filterByRegion
    }
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a2556f9","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/requestTableInns/RequestTableInnsContainer.vue
// module id = 1112
// module chunks = 0